import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import { HtmlColorBadgeStyle } from "./HtmlColorBadgeStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

export const HtmlOrgUnitStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    if (cellValue === null || cellValue === undefined) {
        return null;
    }

    return (
        <HtmlColorBadgeStyle
            className={(() => {
                switch (cellValue) {
                    case undefined:
                    case null:
                    case "ACTIVE":
                        return "aevi-status-badge aevi-active";
                    case "NOT_ACTIVE":
                        return "aevi-status-badge aevi-inactive";
                    default:
                        return "aevi-status-badge aevi-pale-pink";
                }
            })()}
        >
            <sup>
                {(() => {
                    switch (cellValue) {
                        case undefined:
                        case null:
                        case "ACTIVE":
                            return i18n.t("enum.orgUnitStatus.active");
                        case "NOT_ACTIVE":
                            return i18n.t("enum.orgUnitStatus.notActive");
                        case "DEALER_CHANGE":
                            return i18n.t("enum.orgUnitStatus.dealerChange");
                        case "ACTIVE_IN_FUTURE":
                            return i18n.t("enum.orgUnitStatus.activeInFuture");
                        case "INACTIVE_IN_FUTURE":
                            return i18n.t("enum.orgUnitStatus.inactiveInFuture");
                        default:
                            return null;
                    }
                })()}
            </sup>
        </HtmlColorBadgeStyle>
    );
};
